export default "__VITE_ASSET__CDXMwbnd__"